import { render } from "./project_downloads.vue?vue&type=template&id=10ef4603"
import script from "./project_downloads.vue?vue&type=script&lang=js"
export * from "./project_downloads.vue?vue&type=script&lang=js"

import "./project_downloads.vue?vue&type=style&index=0&id=10ef4603&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__